import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import MobileBookingBar from "@/components/site/MobileBookingBar";
import CookieConsent from "@/components/site/CookieConsent";
import RestaurantSchema from "@/components/site/RestaurantSchema";
import { trackPageView } from "@/lib/analytics";

export default function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    // Un solo page_view per cambio di route (il tag è configurato con send_page_view: false).
    const timer = setTimeout(() => trackPageView(pathname), 60);    return () => clearTimeout(timer);
  }, [pathname]);
  return (
    <>
      <a
        href="#contenuto"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[60] focus:bg-wood focus:text-cream focus:px-4 focus:py-2"
      >
        Vai al contenuto
      </a>
      <Header />
      <main id="contenuto" className="pb-16 lg:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileBookingBar />
      <CookieConsent />
      <RestaurantSchema />
    </>
  );
}
